import { create } from 'zustand';
import { isSideMenuClosedInStorage } from '../../menu/domain/menu-storage';

interface CommonState {
    isSideMenuClosed: boolean;
    setIsSideMenuClosed: (_isSidebarClosed: boolean) => void;
}

export const useCommonStore = create<CommonState>()((set) => ({
    isSideMenuClosed: isSideMenuClosedInStorage(),
    setIsSideMenuClosed: (_isSideMenuClosed: boolean) => {
        return set((state: CommonState) => {
            return {
                ...state,
                isSideMenuClosed: _isSideMenuClosed,
            };
        });
    },
}))